import { PageLoading } from "@/components/ui/loading";

/**
 * Suspense fallback shown under the top bar while a lazily loaded page chunk
 * downloads. Reuses the app-wide spinner so a route transition looks like any
 * other wait (visually just the spinner, "Chargement…" for screen readers).
 */
export default function RouteFallback() {
  return <PageLoading className="min-h-[50vh]" />;
}
